export default "__VITE_ASSET__CHLia4Fz__"